<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 10px;">
			<el-button @click="handleAdd">添加新项目</el-button>
			<el-button @click="handleBatchImport">批量导入</el-button>
			<el-button @click="exportData">数据导出</el-button>
			<el-input style="width: 30%;float:right;" placeholder="请输入项目中英文名称或负责人名称" v-model="search_word">
				<el-button slot="append" icon="search"  @click="handleSearch"></el-button>
			</el-input>
		</el-col>
		<el-dialog title="批量导入项目" v-model="batchImportDialogVisible" @close="cancelUpload">
			<el-upload :limit="1"  :on-exceed="handleUploadExceed" :action="uploadUrl"  :on-success="handleUploadSuccess" :on-error="handleUploadError"  :before-upload ="handleBeforeUpload" :headers="uploadHeader" ref="batchImportUpload" :auto-upload="false">
				<span>选取文件:&nbsp;&nbsp;&nbsp;&nbsp;</span><el-button size="small" type="primary">请选择</el-button>
				<a style="display:inline;padding-left:350px;color:#b0b1b3;text-decoration:underline;" v-on:click.stop.prevent="downloadTemplate">模版下载</a>
				<div slot="tip" style="margin-top:55px;" class="el-upload__tip">温馨提示:只能上传excel文件，且不超过20MB</div>
			</el-upload>
			<div slot="footer" class="dialog-footer">
				<el-button @click="cancelUpload">取 消</el-button>
				<el-button type="primary" @click="batchImportOnSubmit">确 定</el-button>
			</div>
        </el-dialog>

		<!--列表-->
		<el-table :data="list_data" size="mini" highlight-current-row v-loading="listLoading" @selection-change="selsChange" style="width: 100%;">
			<el-table-column type="index" width="50">
			</el-table-column>
			<el-table-column prop="projectNameCn" label="中文名称" width="100" sortable>
			</el-table-column>
			<el-table-column prop="projectNameEn" label="英文名称" width="120"  sortable>
			</el-table-column>
			<el-table-column prop="shortName" label="项目简称" width="100" sortable>
			</el-table-column>
			<el-table-column prop="businessGroupNames" label="所属业务组" width="100" sortable>
			</el-table-column>
			<!-- <el-table-column prop="regionCode" label="所属大区" width="100" sortable>
			</el-table-column> -->
			<el-table-column prop="cityName" label="城市" width="120" sortable>
			</el-table-column>
			<el-table-column prop="bulidYear" label="建成年份" min-width="160" sortable>
			</el-table-column>
			<el-table-column prop="catchTime" label="接管日期" min-width="130" sortable>
			</el-table-column>
			<el-table-column prop="expireTime" label="合同到期日期" min-width="130" sortable>
			</el-table-column>
			<el-table-column prop="floorArea" label="项目管理面积" min-width="160" sortable>
			</el-table-column>
			<el-table-column prop="businessType" label="业态" min-width="130" sortable>
			</el-table-column>
			<el-table-column prop="floorHight" label="建筑高度" min-width="100" sortable>
			</el-table-column>
			<el-table-column prop="address" label="地址" min-width="160" sortable>
			</el-table-column>
			<el-table-column prop="zipCode" label="邮编" min-width="130" sortable>
			</el-table-column>
			<el-table-column prop="accountNames" label="项目负责人" min-width="100" sortable>
			</el-table-column>
			<el-table-column label="操作" width="160">
				<template scope="scope">
					<el-button size="small" @click="handleEdit(scope.$index, scope.row)">修改</el-button>
					<el-button size="small" @click="handleDeleteOne(scope.$index, scope.row)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="15" :total="total" style="float:right;">
			</el-pagination>
		</el-col>

		<!--编辑界面-->
		<el-dialog title="编辑" v-model="editFormVisible" :close-on-click-modal="false">
			<el-form :model="editForm" label-width="120px" :rules="editFormRules" ref="editForm">
				<el-form-item prop="projectNameCn" label="中文名称">
					<el-input v-model="editForm.projectNameCn" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item prop="projectNameEn" label="英文名称">
					<el-input v-model="editForm.projectNameEn" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="中英文显示" prop="nameModel">
					<el-radio-group v-model="editForm.nameModel" >
						<el-radio class="radio" :label="0">中文</el-radio>
						<el-radio class="radio" :label="1">英文</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item prop="shortName" label="项目简称">
					<el-input v-model="editForm.shortName" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="所属业务组"  prop="businessGroupIds">
					<el-select  style="width:140px" v-model="businessGroupIdsSelect" @change="handleSelect" :placeholder="editForm.businessGroupNames">
						<el-option v-for="i in bussiessGroupBriefList" :label="i.name" :value="i.id"></el-option>
					</el-select>
				</el-form-item>
				<!-- <el-form-item  label="大区"  prop="regionCode">
					<el-select  style="width: 240px" v-model="editForm.regionCode">
						<el-option v-for="i in regionList" :label="i.name" :value="i.code"></el-option>
					</el-select>
				</el-form-item> -->
				<el-form-item prop="city" label="城市">
					<!-- <el-input v-model="editForm.cityName" auto-complete="off"></el-input> -->
					<el-select   style="width: 240px" filterable remote reserve-keyword :remote-method="getRegionAreaList" placeholder="请输入城市名称搜索" v-model="editForm.city">
						<el-option v-for="i in regionAreaList" :label="i.name" :value="i.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item prop="bulidYear" label="建成年份">
					<el-date-picker v-model="editForm.bulidYear" @change = "bulidYearOnChange" align="right" type="year" placeholder="选择年份"></el-date-picker>
				</el-form-item>
				<el-form-item prop="catchTime" label="接管日期">
					<el-date-picker v-model="editForm.catchTime" type="month" @change = "catchTimeOnChange" placeholder="选择日期"></el-date-picker>
				</el-form-item>
				<el-form-item   style="width: 240px" label="合同到期日期" prop="expireTime">
					<el-date-picker style="width: 240px"  v-model="editForm.expireTime" @change="handleEditFormExpirationTime" type="date" placeholder="请选择" ></el-date-picker>
				</el-form-item>
				<el-table-column prop="expireTime" label="合同到期时间" min-width="130" sortable>
			    </el-table-column>
				<el-form-item prop="floorArea" label="项目管理面积">
					<el-input v-model="editForm.floorArea" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item prop="businessType" label="业态">
					<treeselect :multiple="true" :options="businessTypeList"  valueFormat="id" style="width:240px;" placeholder="请选择业态"  v-model="editForm.businessType" />
				</el-form-item>
				<el-form-item prop="floorHight" label="建筑高度">
					<el-input v-model="editForm.floorHight" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item prop="address" label="地址">
					<el-input v-model="editForm.address" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item prop="zipCode" label="邮编">
					<el-input v-model="editForm.zipCode" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item prop="accountIds" label="项目负责人">
				    <treeselect :multiple="true" :options="shortAcountList_tree"  valueFormat="id" style="width:240px;" placeholder="请选择项目负责人"  v-model="editForm.accountIds" />
				</el-form-item>
				<el-form-item label="包含系统"  prop="sysIdJoinCodes">
					<treeselect :multiple="true" :options="projectSysSourceList" :isShowSysCodeInput="true" valueFormat="object" style="width:240px;" placeholder="请选择包含系统" v-model="editForm.sysIdJoinCodes" />
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="editFormVisible = false;">取消</el-button>
				<el-button type="primary" v-bind:disabled="editSubmitButtonDisabled"  @click.native="editSubmit" :loading="editLoading">提交</el-button>
			</div>
		</el-dialog>

		<!--新增界面-->
		<el-dialog title="添加新项目" v-model="addFormVisible" :close-on-click-modal="false" @close="cancelAddSubmit">
			<el-form :model="addForm" label-width="120px" :rules="addFormRules" ref="addForm">
				<el-form-item prop="projectNameCn" label="中文名称">
					<el-input v-model="addForm.projectNameCn" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item prop="projectNameEn" label="英文名称">
					<el-input v-model="addForm.projectNameEn" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="中英文显示" prop="nameModel">
					<el-radio-group v-model="addForm.nameModel" >
						<el-radio class="radio" :label="0">中文</el-radio>
						<el-radio class="radio" :label="1">英文</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item prop="shortName" label="项目简称">
					<el-input v-model="addForm.shortName" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="所属业务组"  prop="businessGroupIds">
					<el-select  style="width:140px" v-model="addForm.businessGroupIds"> 
						<el-option v-for="i in bussiessGroupBriefList" :label="i.name" :value="i.id"></el-option>
					</el-select>
				</el-form-item>
				<!-- <el-form-item  label="大区"  prop="regionCode">
					<el-select  style="width: 240px" v-model="addForm.regionCode">
						<el-option v-for="i in regionList" :label="i.name" :value="i.code"></el-option>
					</el-select>
				</el-form-item> -->
				<el-form-item prop="city" label="城市">
					<!-- <el-input v-model="addForm.cityName" auto-complete="off"></el-input> -->
					<el-select   style="width: 240px" filterable remote reserve-keyword :remote-method="getRegionAreaList" placeholder="请输入城市名称搜索" v-model="addForm.city">
						<el-option v-for="i in regionAreaList" :label="i.name" :value="i.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item prop="bulidYear" label="建成年份">
					<el-date-picker v-model="addForm.bulidYear" align="right" @change = "bulidYearOnChange" type="year" placeholder="选择年份"></el-date-picker>
				</el-form-item>
				<el-form-item prop="catchTime" label="接管日期">
					<el-date-picker v-model="addForm.catchTime" type="month" @change = "catchTimeOnChange" placeholder="选择日期"></el-date-picker>
				</el-form-item>
				<el-form-item   style="width: 240px" label="合同到期日期" prop="expireTime">
					<el-date-picker style="width: 240px"  v-model="addForm.expireTime" @change="handleAddFormExpirationTime" type="date" placeholder="请选择" ></el-date-picker>
				</el-form-item>
				<el-form-item prop="floorArea" label="项目管理面积">
					<el-input v-model="addForm.floorArea" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item prop="businessType" label="业态">
					<treeselect :multiple="true" :options="businessTypeList"  valueFormat="id" style="width:240px;" placeholder="请选择业态"  v-model="addForm.businessType" />
				</el-form-item>
				<el-form-item prop="floorHight" label="建筑高度">
					<el-input v-model="addForm.floorHight" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item prop="address" label="地址">
					<el-input v-model="addForm.address" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item prop="zipCode" label="邮编">
					<el-input v-model="addForm.zipCode" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item prop="accountIds" label="项目负责人">
				    <treeselect :multiple="true" :options="shortAcountList_tree"  style="width:240px;" placeholder="请选择项目负责人" v-model="addForm.accountIds" />
				</el-form-item>
				<el-form-item label="包含系统"  prop="sysIdJoinCodes">
					<treeselect :multiple="true" :options="sysSourceList" :isShowSysCodeInput="true" valueFormat="object"  style="width:240px;" placeholder="请选择包含系统" v-model="addForm.sysIdJoinCodes" />
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="cancelAddSubmit">取消</el-button>
				<el-button type="primary" v-bind:disabled="addSubmitButtonDisabled" @click.native="addSubmit" :loading="addLoading">提交</el-button>
			</div>
		</el-dialog>
	</section>
</template>

<script>
	import api from '@/api';
	import tools from '@/util/tools';
	import Treeselect from '@riophae/vue-treeselect'
	import global from '@/config/global_config'
	import Vue from 'vue'
	import router from '@/router/index.js'
	
	export default {
		components: { Treeselect },
		data() {
			return {
				filters: {
					name: ''
				},
				list_data: [],
				total: 0,
				page: 1,
				listLoading: false,
				sels: [],
				bussiessGroupBriefList:[],
				editFormVisible: false,
				editLoading: false,
				editFormRules: {
					projectNameCn: [
						{ required: true, message: '中文名称不能为空', trigger: 'blur' },
						{ min: 1, max: 32, message: '输入长度在1到32个字符之间'}
					],  
					projectNameEn: [
						{ required: true, message: '英文名称不能为空', trigger: 'blur' },
						{ min: 1, max: 32, message: '输入长度在1到32个字符之间'}
					],
					nameModel: [
						{ type:'number',required: true, message: '中英文显示不能为空', trigger: 'blur' }
					],
					city: [     
						// { min: 1, max: 32, message: '输入长度在1到32个字符之间'}
						// { required: true, message: '城市不能为空',trigger: 'blur'},
					],
					floorArea: [
						{ required: true, message: '项目管理面积不能为空',trigger: 'blur'},
						{ pattern: /^\d+(\.\d+)?$/ ,message: '项目管理面积只能输入数字'}
					],
					floorHight: [
						{pattern: /^\d+(\.\d+)?$/ ,message: '建筑高度只能输入数字'}
					],
					address: [
						{ required: true, message: '地址不能为空', trigger: 'blur' },
						{ min: 1, max: 80, message: '输入长度在1到80个字符之间'}
					],
					zipCode: [
						{ min: 1, max: 12, message: '输入长度在1到12个字符之间'}
					],
					regionCode:[
					    { required: true, message: '请选择大区'},
					],
					shortName: [
						{ required: true, message: '项目简称不能为空', trigger: 'blur' },
						{ min: 1, max: 32, message: '输入长度在1到32个字符之间'}
					]
				},
				editForm: {

				},
				sysSourceList_Original:[],
				sysSourceList:[],
				projectSysSourceList_Original: [],
			    projectSysSourceList: [],
				addFormVisible: false,
				addLoading: false,
				addFormRules: {
					projectNameCn: [
						{ required: true, message: '中文名称不能为空', trigger: 'blur' },
						{ min: 1, max: 32, message: '输入长度在1到32个字符之间'}
					],  
					projectNameEn: [
						{ required: true, message: '英文名称不能为空', trigger: 'blur' },
						{ min: 1, max: 32, message: '输入长度在1到32个字符之间'}
					],
					nameModel: [
						{ type:'number',required: true, message: '中英文显示不能为空', trigger: 'blur' }
					],
					city: [     
						// { required: true, message: '城市不能为空',trigger: 'blur'},
					],
					floorArea: [
						{ required: true, message: '项目管理面积不能为空',trigger: 'blur'},
						{ pattern: /^\d+(\.\d+)?$/ ,message: '项目管理面积只能输入数字'}
					],
					floorHight: [
						{pattern: /^\d+(\.\d+)?$/ ,message: '建筑高度只能输入数字'}
					],
					address: [
						{ required: true, message: '地址不能为空', trigger: 'blur' },
						{ min: 1, max: 80, message: '输入长度在1到80个字符之间'}
					],
					zipCode: [
						{ min: 1, max: 12, message: '输入长度在1到12个字符之间'}
					],
					regionCode:[
					    { required: true, message: '请选择大区'},
					],
					shortName: [
						{ required: true, message: '项目简称不能为空', trigger: 'blur' },
						{ min: 1, max: 32, message: '输入长度在1到32个字符之间'}
					]
				},
				addForm: {
				},
				businessGroupIdsSelect:'',
				sysSourceListVisible:false,
				projectTreeDialogVisible:false,
				shortAcountList:[],
				shortAcountList_tree:[],
				batchImportDialogVisible:false,
				uploadUrl:global.apiBaseURL+'/project/upload',
				uploadHeader:{access_token:global.getAccessToken()},
				search_word:'',
				bulidYear:'',
				catchTime:'',
				editSubmitButtonDisabled:false,
				addSubmitButtonDisabled:false,
				businessTypeList:[],
				regionAreaList:[],
				expirationTime:'',
				// regionList:[]
			}
		},
		methods: {
			checkinlist(){
				 console.log(this.editForm.sysIdJoinCodes);
			},
			handleCurrentChange(val) {
				this.page = val;
				this.get_list_data();
			},
			handleAddFormExpirationTime(val){
				if(val == null || val == '') return;
				let split_tmp = val.split('-');
				// this.expirationTime = split_tmp[0]+split_tmp[1]+split_tmp[2];
				this.expirationTime = val;
			},
			handleEditFormExpirationTime(val){
				if(val == null || val == '') return;
				let split_tmp = val.split('-');
				// this.expirationTime = split_tmp[0]+split_tmp[1]+split_tmp[2];
				this.expirationTime = val;
			},
			handleSearch(){
				this.get_list_data();
			},
			hiddenSysSourceList(){
				this.sysSourceListVisible = false;
			},
			showSysSourceList(){
				this.sysSourceListVisible = true;
			},
			filterNode(value, data) {
				if (!value) return true;
				return data.label.indexOf(value) !== -1;
			},
			showProjectTree(){
				this.projectTreeDialogVisible = true;
				return;
			},
			projectTreeOnSubmit(){
				let leafCheckedNodes = [];
				let checkedNodes = this.$refs.projectTree.getCheckedNodes();
				if(checkedNodes){
					checkedNodes.forEach(one => {
						if(!one.children)leafCheckedNodes.push(one.id);
					});
					console.log(leafCheckedNodes);
					this.projectIds =  leafCheckedNodes.join(',');
				}
				this.projectTreeDialogVisible = false;
			},
			get_list_data() {
				let param = {
					keys:this.search_word,
					pageNum: this.page,
					pageSize: 15
				};
				this.listLoading = true;
				api.project_detailList_request(param).then((res) => {
					this.total = res.data.total;
					this.list_data = res.data.list;
					this.listLoading = false;
				}).catch((e) => {
					console.log(e);
					tools.error(new Vue(),e.message);
				});
				this.listLoading = false;
			},
			handleDeleteOne: function (index, row) {
				this.$confirm('确认删除该记录吗?', '提示',{showClose:false}).then(() => {
					let param = { ids: row.id };
					api.project_remove_request(param).then(
						res => {
							tools.success(this,"删除成功");
							this.get_list_data();
						}
					)	
				}).catch((e) => {
					console.log(e);
					if(e.message)tools.error(new Vue(),e.message);
				});
			},
			handleEdit: function (index, row) {
				this.regionAreaList=[{id:row.city,name:row.cityName}]
				let param = {projectId:row.id};
				this.listLoading = true;
				this.projectSysSourceList = [];
				if(row.expirationTime && row.expirationTime.length == 8){
					let year = row.expirationTime.substr(0,4);
					let month = row.expirationTime.substr(4,2);
					let date = row.expirationTime.substr(6,2);
					// this.expirationTime = year+""+month+""+date;
					this.expirationTime = year+"-"+month+"-"+date;
					this.editForm.expirationTime = year+"-"+month+"-"+date;
				}
				else{
					this.expirationTime = "";
					this.editForm.expireTime = "";
				}
				api.project_getProjectAcountAble_request(param).then((res) => {
					let temp = [];
					api.project_getProjectSysCodeList_request(param).then((resInner) => {
						let tempInner = [];
						if(this.sysSourceList_Original){
							for (let index = 0; index < this.sysSourceList_Original.length; index++) {
								//this.sysSourceList_Original[index].code
						        this.projectSysSourceList[index] = {id:this.sysSourceList_Original[index].id ,label:this.sysSourceList_Original[index].name,code:''};
						    }
						}
						for(let index_tmp = 0; index_tmp < this.projectSysSourceList.length; index_tmp++) {
							for (let index = 0; index < resInner.data.length; index++) {
								if( resInner.data[index].id == this.projectSysSourceList[index_tmp].id ){
									this.projectSysSourceList[index_tmp].code = resInner.data[index].joinCode;
								}
							}
						}
						for (let index = 0; index < res.data.length; index++) {
							temp[index] = {id:res.data[index].id ,label:res.data[index].code};
					    }
						this.shortAcountList_tree = temp;
						this.shortAcountList = res.data;
						this.bulidYear = row.bulidYear,
						this.catchTime = row.catchTime,
						this.editForm = Object.assign({}, row);
						if(row.businessGroupIds){
							this.editForm.businessGroupIds = parseInt(row.businessGroupIds);
							this.businessGroupIdsSelect = this.editForm.businessGroupIds;
						}
						else{
							this.businessGroupIdsSelect = '';
						}
						if(!this.businessGroupIdsSelect)this.editForm.businessGroupNames = '请选择';
						if(this.editForm.floorArea)this.editForm.floorArea = String(this.editForm.floorArea);
						if(this.editForm.floorHight)this.editForm.floorHight = String(this.editForm.floorHight);
						if(row.accountIds){
							this.editForm.accountIds = row.accountIds.split('|');
							let accountIdsTemp = [];
							this.editForm.accountIds.forEach(element => {
								accountIdsTemp.push(parseInt(element));
							});
							this.editForm.accountIds = accountIdsTemp;
						}
						else this.editForm.accountIds = [];
						if(row.businessType){
							this.editForm.businessType = row.businessType.split('+');
						}
						else this.editForm.businessType = [];
						this.editForm.sysIdJoinCodes = [];
						if(row.sysNameIds){
							let split = row.sysNameIds.split('|');
							let sysNameIds = [];
							let sysNameIdsTemp = [];
							split.forEach(one => {
								let split_tmp = one.split(':');
								for (let index = 0; index < resInner.data.length; index++) {
								   if( resInner.data[index].id == parseInt(split_tmp[1]) ){
									    sysNameIds.push({id:parseInt(split_tmp[1]),code:resInner.data[index].joinCode,projectSysSourceList:this.projectSysSourceList});
									}
								}
							});
							this.editForm.sysIdJoinCodes = sysNameIds;
						}
						else{
							this.editForm.sysIdJoinCodes.push({projectSysSourceList:this.projectSysSourceList});
						}
						this.editFormVisible = true;
						}).catch((e) => {
							console.log(e);
						});
				}).catch((e) => {
					tools.error(new Vue(),e.message);
				});
				this.listLoading = false;
			},
			handleAdd: function () {
				let param = {};
				this.listLoading = true;
				api.project_getProjectAcountAble_request(param).then((res) => {
					let temp = [];
					console.log(res.data);
					for (let index = 0; index < res.data.length; index++) {
						temp[index] = {id:res.data[index].id ,label:res.data[index].code};
					}
					this.shortAcountList_tree = temp;
					this.shortAcountList = res.data;
					this.addFormVisible = true;
					this.bulidYear = '',
					this.catchTime = '',
					this.addForm = {
						nameModel:0,
					};	
				}).catch((e) => {
					console.log(e);
				});
				this.listLoading = false;
			},
			handleSelect(index){
				this.editForm.businessGroupIds = this.businessGroupIdsSelect;
            },
			editSubmit: function () {
				this.$refs.editForm.validate((valid) => {
					if (valid) {
						this.editSubmitButtonDisabled=true;
						let accountIds,sysIdJoinCodes,businessType;
						if(this.editForm.accountIds)accountIds = this.editForm.accountIds.join(',');
						else accountIds ='';
						if(this.editForm.businessType) businessType = this.editForm.businessType.join('+'); 
						else businessType = '';
						console.log(this.editForm.sysIdJoinCodes);
						if(this.editForm.sysIdJoinCodes){
							let temp = [];
							this.editForm.sysIdJoinCodes.forEach(el => {
								this.sysSourceList_Original.forEach(one => {
									if(one.id == el.id){
										temp.push(one.id+':'+el.code);
									}
								});
							});
							sysIdJoinCodes = temp.join(',');
						}
						let param = {
							id:this.editForm.id,
							projectNameCn:this.editForm.projectNameCn,
							projectNameEn:this.editForm.projectNameEn,
							address:this.editForm.address,
							floorArea:this.editForm.floorArea,
							nameModel:this.editForm.nameModel,
							accountIds:accountIds,
							businessGroupIds:this.editForm.businessGroupIds,
							sysIdJoinCodes:sysIdJoinCodes,
							floorHight:this.editForm.floorHight,
							bulidYear:this.bulidYear,
							catchTime:this.catchTime,
							businessType:businessType,
							zipCode:this.editForm.zipCode,
							city:this.editForm.city,
							regionCode:this.editForm.regionCode,
							shortName:this.editForm.shortName,
						};
						param.expireTime = this.expirationTime;
						this.listLoading = true;
						let self = this;
						api.project_update_request(param).then((res) => {
							this.editFormVisible = false;
							this.$refs.editForm.resetFields();
							this.editSubmitButtonDisabled=false;
							tools.success(this,"编辑成功");
							this.get_list_data();
						}).catch((e) => {
							console.log(e);
							self.editSubmitButtonDisabled=false;
							tools.error(new Vue(),e.message);
						});
						this.listLoading = false;
					}
				});
			},
			addSubmit: function () {
				this.$refs.addForm.validate((valid) => {
					if (valid) {
						this.addSubmitButtonDisabled=true;
						if(this.addForm.accountIds) this.addForm.accountIds = this.addForm.accountIds.join(','); 
						else this.addForm.accountIds = '';
						if(this.addForm.businessType) this.addForm.businessType = this.addForm.businessType.join('+'); 
						else this.addForm.businessType = '';
						if(this.addForm.sysIdJoinCodes){
							let temp = [];
							this.addForm.sysIdJoinCodes.forEach(el => {
								this.sysSourceList_Original.forEach(one => {
									if(one.id == el.id){
										temp.push(one.id+':'+el.code);
									}
								});
							});
							this.addForm.sysIdJoinCodes = temp.join(',');
						}
						this.addForm.bulidYear = this.bulidYear;
						this.addForm.catchTime = this.catchTime;
						let param = Object.assign({}, this.addForm);
						param.expireTime = this.expirationTime;
						this.listLoading = true;
						let self = this;
						api.project_add_request(param).then((res) => {
							this.addFormVisible = false;
							this.$refs.addForm.resetFields();
							this.addForm.sysIdJoinCodes = '';
							this.addForm.accountIds = '';
							this.addForm.businessType = '';
							this.addSubmitButtonDisabled=false;
							tools.success(this,"新增成功");
							this.get_list_data();
						}).catch((e) => {
							console.log(e);
							self.addSubmitButtonDisabled=false;
							tools.error(new Vue(),e.message);
						});
						this.listLoading = false;
					}
				});
			},
			getBussiessGroupbriefList: function () {
				let param = {};
				this.listLoading = true;
				api.bussiessGroupBriefList_request(param).then((res) => {
					this.bussiessGroupBriefList = res.data;	
				}).catch((e) => {
					console.log(e);
				});
				this.listLoading = false;
			},
			getProjectSysCodeList: function () {
				let param = {};
				this.listLoading = true;
				api.project_getProjectSysCodeList_request(param).then((res) => {
					let temp = [];
					for (let index = 0; index < res.data.length; index++) {
						temp[index] = {id:res.data[index].id ,label:res.data[index].name,code:res.data[index].joinCode};
					}
					this.projectSysSourceList_Original = res.data;
					this.projectSysSourceList = temp;	
				}).catch((e) => {
					console.log(e);
				});
				this.listLoading = false;
			},
			getSysSourceList: function () {
				let param = {};
				this.listLoading = true;
				api.system_getSysSourceList_request(param).then((res) => {
					let temp = [];
					for (let index = 0; index < res.data.length; index++) {
						//res.data[index].code
						temp[index] = {id:res.data[index].id ,label:res.data[index].name,code:''};
					}
					this.sysSourceList_Original = res.data;
					this.sysSourceList = temp;	
				}).catch((e) => {
					console.log(e);
				});
				this.listLoading = false;
			},
			getBusinessTypeList: function () {
				let param = {};
				this.listLoading = true;
				api.project_getBusinessTypeList_request(param).then((res) => {
					let temp = [];
					for (let index = 0; index < res.data.length; index++) {
						temp[index] = {id:res.data[index] ,label:res.data[index],code:res.data[index]};
					}
					this.businessTypeList = temp;	
				}).catch((e) => {
					console.log(e);
				});
				this.listLoading = false;
			},
			getShortAcountList: function (projectId) {
				let param = {projectId:projectId};//identity:'level-three',keys:''
				this.listLoading = true;
				api.project_getProjectAcountAble_request(param).then((res) => {
					let temp = [];
					for (let index = 0; index < res.data.length; index++) {
						temp[index] = {id:res.data[index].id ,label:res.data[index].code};
					}
					this.shortAcountList_tree = temp;
					this.shortAcountList = res.data;	
				}).catch((e) => {
					console.log(e);
				});
				this.listLoading = false;
			},
			handleBatchImport:function () {
				this.batchImportDialogVisible = true;
			},
			downloadTemplate(){
				let param = {};
				api.project_getImportTemplate_request(param).then((res) => {
					let blob = new Blob([res.data],{type:'application/vnd.ms-excel'});
					let fileLink = document.createElement('a')
					fileLink.href = window.URL.createObjectURL(blob);
					fileLink.download =  'template_project'+'_' + new Date().getTime() + '.xls'
					fileLink.click();
				}).catch((e) => {
					console.log(e);
					tools.error(new Vue(),e.message);
				});
			},
			handleUploadExceed(files, fileList){
				tools.error(this,'每次只能上传一个文件!');
				return false
			},
			handleBeforeUpload(file) {
				const isLt2M = file.size / 1024 / 1024 < 20;
				if (!isLt2M) {
					tools.error(this,'文件过大,注意不能超过20MB!');
					return false
				}
				let Xls = file.name.split('.');
                if(Xls[1] === 'xls'||Xls[1] === 'xlsx'){
                    return file
                }else {
                    tools.error(this,'上传文件只能是 xls/xlsx 格式!')
                    return false
				}
			},
			batchImportOnSubmit(){
				this.$refs.batchImportUpload.submit();
			},
			cancelUpload(){
				this.batchImportDialogVisible = false;
				this.$refs.batchImportUpload.clearFiles();
			},
			handleUploadSuccess(res,file,fileList){
				if(res.code == 200) {
					tools.success(this,"上传成功");
					this.batchImportDialogVisible = false;
					this.$refs.batchImportUpload.clearFiles();
					this.get_list_data();
				}
                else {
					if(res.code == 402) {
						sessionStorage.removeItem('user');
						sessionStorage.removeItem('localRoutes');
						tools.error(new Vue(),'会话已过期,请重新登录');
						router.push('/login');
						location.reload();
					}
					else{
						let errorMessage = '';
						if(res.errorMap){
							Object.keys(res.errorMap).forEach(key => {
								errorMessage += key+"字段:"+res.errorMap[key]+','
							});
							errorMessage = res.msg + '(详细原因：'+ errorMessage +')';
						}
						else errorMessage = res.msg;
						tools.error(new Vue(),errorMessage);
				    }
				}
			},
			handleUploadError(){
				tools.error(this,res.data.msg);
			},
			handleDataExport:function () {

			},
			selsChange: function (sels) {
				this.sels = sels;
			},
			exportData:function () {
				let param = {
					keys:this.search_word,
				};
				this.listLoading = true;
				api.project_exportData_request(param).then((res) => {
					let blob = new Blob([res.data],{type:'application/vnd.ms-excel'});
					let fileLink = document.createElement('a')
					fileLink.href = window.URL.createObjectURL(blob);
					fileLink.download =  'projectList'+'_' + new Date().getTime() + '.xls'
					fileLink.click();
				}).catch((e) => {
					console.log(e);
					tools.error(new Vue(),e.message);
				});
				this.listLoading = false;
			},
			bulidYearOnChange(val) {  
				this.bulidYear = val;
				if(this.editFormVisible) this.editForm.bulidYear =val;
				else this.addForm.bulidYear =val;
			},
			catchTimeOnChange(val) {  
				this.catchTime = val;
				if(this.editFormVisible) this.editForm.catchTime =val;
				else this.addForm.catchTime =val;
			},
			updateAcountListTreeValue(state, value){
				state.value = value
			},
			cancelAddSubmit(){
				this.addFormVisible = false;
				this.$refs.addForm.resetFields();
				if(this.addSubmitButtonDisabled)this.addSubmitButtonDisabled = false;
			},
			// getRegionList: function () {
			// 	let param = {};
			// 	this.listLoading = true;
			// 	api.getRegionList(param).then((res) => {
			// 		this.regionList = res.data;
			// 	}).catch(function (e) {
			// 		console.log(e);
			// 	});
			// 	this.listLoading = false;
			// }
			getRegionAreaList: function (query) {
				console.log(query)
				let param = {keys:query};
				this.listLoading = true;
				api.account_getRegionAreaList_request(param).then((res) => {
					if(res.data){
						this.regionAreaList = res.data;
					}
				}).catch(function (e) {
					console.log(e);
				});
				this.listLoading = false;
			}
		},
		mounted() {
			this.get_list_data();
			this.getBussiessGroupbriefList();
			this.getSysSourceList();
			this.getShortAcountList(null);
			this.getBusinessTypeList();
			// this.getRegionList();
		}
	}

</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// project_list.vue?6eace995